import Job from 'models/Job';

import Component from './component';

export enum AgremeentTypes {
	JDG = 'Jednoosobowa działalność gospodarcza',
}

export interface Props {
	title: string;
	job: {
		mapLabel: string;
	}
	jobs: Job[];
}

Component.defaultProps = {};
export default Component;
